var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcFilterBold = function SvgIcFilterBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.03 16.593a1 1 0 0 1 1-1h11.244a1 1 0 1 1 0 2H4.029a1 1 0 0 1-1-1M8.061 6.9a1 1 0 0 1 1-1h10.38a1 1 0 1 1 0 2H9.061a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 6.846C3 4.992 4.513 3.5 6.363 3.5s3.363 1.492 3.363 3.346-1.512 3.347-3.363 3.347S3 8.7 3 6.846M6.363 5.5C5.603 5.5 5 6.11 5 6.846s.604 1.347 1.363 1.347c.76 0 1.363-.61 1.363-1.347 0-.736-.603-1.346-1.363-1.346M14.274 16.554c0-1.855 1.513-3.346 3.364-3.346A3.354 3.354 0 0 1 21 16.554a3.354 3.354 0 0 1-3.362 3.346c-1.851 0-3.364-1.491-3.364-3.346m3.364-1.346c-.76 0-1.364.61-1.364 1.346s.603 1.346 1.364 1.346c.759 0 1.362-.61 1.362-1.346s-.603-1.346-1.362-1.346",
    clipRule: "evenodd"
  })));
};
export default SvgIcFilterBold;